<template>
	<div class="sign-up">
		<HeaderSignUp :class="{ 'sign-up__header-hide': showEmailSignUp }" class="sign-up__header">
			<template #title>{{ $t('signup.title') }}</template>
			<template #subtitle>
				{{ $t('signup.subtitle') }}
			</template>
		</HeaderSignUp>
		<div class="sign-up__container">
			<div class="container__left-container">
				<SignUpForm
					v-if="!showEmailSignUp"
					class="left-container__form"
					@signUpMobile="showEmailSignUp = true"
				/>
				<MobileEmailSignUp v-else />
			</div>
			<div class="container__right-container">
				<img
					src="@/assets/sign-up/testimonial.png"
					class="right-container__img-testimonial"
				/>
			</div>
		</div>
		<noscript>
			<iframe class="gtm-ns" src="https://www.googletagmanager.com/ns.html?id=GTM-KL8XX6V" />
		</noscript>
	</div>
</template>

<script setup>
definePageMeta({
	layout: 'sign-up',
})
const { t } = useI18n()

useHead({
	title: t('header_title.sign_up'),
})
</script>

<script>
import SignUpForm from '@/components/sign-up/sign-up-form'

export default {
	components: {
		SignUpForm,
	},

	data() {
		return {
			showEmailSignUp: false,
		}
	},

	created() {
		this.activateGtm(window, document, 'script', 'dataLayer', 'GTM-KL8XX6V')
	},

	beforeMount() {
		this.$store.dispatch('mixpanel/trackPage', {
			mixpanel: this.$mixpanel,
			pageName: 'page-signup',
		})
	},
	methods: {
		activateGtm(w, d, s, l, i) {
			w[l] = w[l] || []
			w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
			const f = d.getElementsByTagName(s)[0]
			const j = d.createElement(s)
			const dl = l !== 'dataLayer' ? '&l=' + l : ''
			j.async = true
			j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
			f.parentNode.insertBefore(j, f)
		},
	},
}
</script>
<style scoped lang="postcss">
.sign-up {
	display: flex;
	flex-direction: column;
	&__header {
		margin: 50px 0 20px 0;
	}
	&__container {
		display: flex;
	}
}
.container {
	&__left-container {
		width: 50%;
		display: flex;
	}
	&__right-container {
		width: 50%;
		display: flex;
	}
}

.right-container {
	&__img-testimonial {
		width: 400px;
		height: 400px;
		margin: auto auto auto 100px;
	}
}

.left-container {
	&__form {
		margin-left: auto;
	}
}

.gtm-ns {
	width: 0;
	height: 0;
	visibility: hidden;
	display: none;
}

.mail-sign-up {
	width: 365px !important;
	height: 256px !important;
}

@media screen and (max-width: 770px) {
	.sign-up {
		&__header {
			margin: 10px 0px;
		}
		&__header-hide {
			display: none;
		}
	}
	.container {
		&__left-container {
			width: 100%;
			padding: 0px 30px 30px 30px;
		}
		&__right-container {
			display: none;
		}
	}
}
</style>
